import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";

interface RoleBasedComponentProps {
  allowedRoles: string[];
  children: ReactNode;
}

export default function RoleBasedComponent({
  allowedRoles,
  children,
}: RoleBasedComponentProps) {
  const { account } = useSelector((state: RootState) => state.account);

  const userRole = account?.role;

  const isAllowed = userRole !== undefined && allowedRoles.includes(userRole);

  if (!isAllowed) return null;

  return <>{children}</>;
}
